<template>

<div>
  <div class = "hero">
    <div class = "hero-body">
      <div class = "container">
        <div class = "">
          <div class = "title is-uppercase title-font has-text-white spacing-bottom" style = "font-size: 5rem">
           <mark class = "has-text-white"> Toldos </mark>
          </div>
          <div class = "subtitle is-1 is-uppercase title-font has-text-primary">
            Huertabajo
          </div>
        </div>
        <div class = "has-text-black">
          <div class = "is-size-4-desktop is-size-5-mobile">
            Venta e instalación de toldos
          </div>
          <div class = "is-size-4-desktop is-size-6-mobile">
            C/Austria, 7 - Sanlúcar la Mayor (Sevilla)
          </div>  
          <div class = "is-size-4-desktop is-size-6-mobile">
            Tlf - 95 570 08 81 - móvil - 651 45 32 87
          </div>  
          <div class = "is-size-4-desktop is-size-6-mobile">
            toldoshuertabajo@gmail.com
          </div>  
        </div>
      </div>
    </div>
  </div>

<div class = "level is-mobile">

    <a class = "level-item navbarelement subtitle has-text-weight-bold" @click="scrollMeTo('start')">
        Inicio 
    </a>

    <a class = "level-item navbarelement subtitle has-text-weight-bold is-hidden-mobile navbarborder" @click="scrollMeTo('gallery')">
        Galería
    </a>

    <a class = "level-item navbarelement subtitle has-text-weight-bold is-hidden-mobile navbarborder" @click="scrollMeTo('budget')">
        Solicita presupuesto
    </a>

    <a class = "level-item navbarelement subtitle has-text-weight-bold is-hidden-mobile navbarborder" @click="scrollMeTo('budget')">
        Contacto
    </a>

    <a class = "level-item navbarelement subtitle has-text-weight-bold is-hidden-mobile navbarborder" @click="scrollMeTo('map')">
        Dónde estamos
    </a>


    <div class = "level-right is-hidden-tablet">
      <div class = "level-item dropdown is-right"  style = "margin-right: 0.75rem; margin-left: 0.75rem; padding-left:0.75rem;" :class = "{'is-active': dropdownActive}" >
        <div class = "dropdown-trigger"> 
          <a @click="dropdownActive = !dropdownActive"> <font-awesome-icon class = "is-size-3 has-text-black" :icon = "['fas', 'bars']"/> </a>
        </div>
        <div class = "dropdown-menu">
          <div class = "dropdown-content">
            <a href = "#" class = "dropdown-item subtitle has-text-weight-bold" @click="scrollMeTo('gallery')">
              Galería
            </a>
            <hr class="dropdown-divider">
            <a href = "#" class = "dropdown-item subtitle has-text-weight-bold" @click="scrollMeTo('budget')">
              Solicita presupuesto
            </a>
            <hr class="dropdown-divider">
            <a href = "#" class = "dropdown-item subtitle has-text-weight-bold" @click="scrollMeTo('budget')">
              Contacto
            </a>
            <hr class="dropdown-divider">
            <a href = "#" class = "dropdown-item subtitle has-text-weight-bold" @click="scrollMeTo('map')">
              Dónde estamos
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
</template>

<script>

export default {
  name: 'TitleHeader',
  data(){
    return {
      dropdownActive: false
    }
  },
  methods: {
    scrollMeTo: function(refName) {
      this.dropdownActive = false;
      this.$emit('to-'+refName);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.level-item {
  padding-top: 0.7rem; 
  padding-right: 0.8rem;
}

mark {
  background-color: #A5251C;
  padding-left: 0.3rem;
  padding-right: 0.3rem;
  line-height: 1.05;
  height: 0.8em;
  letter-spacing: -0.03em;
  display: inline-block;
}

.spacing-bottom {
  margin-bottom: -1rem !important;
}

.title-font {
  font-family: "Baloo Bhaina 2";
  font-weight: bolder;
}

h1, h2 {
  font-weight: normal;
}
div {
  text-align: center;
  font-family: 'Century Gothic', 'Tahoma', 'Verdana'
}
.hero {
  background-image: linear-gradient(
      rgba(228, 228, 228, 0.5),
      rgba(228, 228, 228, 0.5)
    ),url('../../public/fotos/5.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  
}
.spacedicon {
  margin-left:10px;
}

.navbarelement:hover {
  /*background-color: #dddddd;*/
  background-color: #0082C9;
  color: white;
}

.navbarelement {
  padding-top: 1rem;
  padding-bottom: 1rem;
  margin-right: 0px !important;
}

.navbarborder {
  /* TODO PONER ESTO AHI PARA TENER RAYITAS EN LA BARRA DE NAVEGACION */
  border: dashed #0082C9;
  border-width: 0px 0px 0px 3px;
  /*border-width: 2px 1px 2px 1px;*/
}

</style>

